import { CreativeSetupFlowPageModel } from 'containers/Creatives/CreativeSetupFlow/CreativeSetupFlowPageModelInterface';
import { RichProductNativeFormModel } from './RichProductNativeFormModel';
import { Product } from 'core/product/Product';

export class BrandLedFormModel extends RichProductNativeFormModel {

  constructor (
    flowPageModel: CreativeSetupFlowPageModel,
    products: Product[] = []
  ) {
    super(flowPageModel, products, [{ width: 1920, height: 640 }]);
  }
}
